import { render, staticRenderFns } from "./ChoosePurchaseType.vue?vue&type=template&id=08a87122&scoped=true&"
import script from "./ChoosePurchaseType.vue?vue&type=script&lang=js&"
export * from "./ChoosePurchaseType.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePurchaseType.vue?vue&type=style&index=0&id=08a87122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a87122",
  null
  
)

export default component.exports